import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {AngularFirestore} from "@angular/fire/compat/firestore";
import {MatSelectChange} from "@angular/material/select";
import {Observable, Subject, takeUntil} from "rxjs";
import {Units} from "../../../interfaces/Units";
import {MatTableDataSource} from "@angular/material/table";
import {Centre} from "../../../interfaces/Centres";
import {CentreService} from "../../../services/centre.service";
import {UnitService} from "../../../services/unit.service";
import {MatDialog} from "@angular/material/dialog";
import {MatSnackBar} from "@angular/material/snack-bar";
import {Unit} from "chart.js/dist/scales/scale.time";
import {FullChild} from "../../../interfaces/FullChild";
import {AdmissionType} from "../../../models/AdmissionTypes";
import {MatPaginator} from "@angular/material/paginator";
import {MatSort} from "@angular/material/sort";
import * as XLSX from 'xlsx';
import {saveAs} from 'file-saver';

@Component({
    selector: 'app-custom-unit-report',
    templateUrl: './custom-unit-report.component.html',
    styleUrls: ['./custom-unit-report.component.scss']
})
export class CustomUnitReportComponent implements OnInit, OnDestroy {
    start: Date | undefined
    end: Date | undefined
    selectedCentre!: Centre
    unitSelected: Unit | undefined
    unitsArray: Units[] = []
    private _destroyed$ = new Subject<void>()
    $center: Observable<Centre[]>
    children: FullChild[] = []
    units: Units[] = []
    displayedColumns: string[] = ['position', 'name', 'centre', 'diagnosis'];
    dataSource: MatTableDataSource<FullChild>
    showDownload=false
    @ViewChild(MatPaginator) paginator!: MatPaginator;
    @ViewChild(MatSort) sort!: MatSort;

    constructor(private readonly mFirestore: AngularFirestore,
                private mCentreService: CentreService,
                private mUnitService: UnitService,
                private dialog: MatDialog,
                public _snackBar: MatSnackBar) {
        this.$center = mCentreService.getAllCentres()
        this.dataSource = new MatTableDataSource()
    }

    ngOnInit(): void {
    }

    ngOnDestroy(): void {
        this._destroyed$.next();
        this._destroyed$.complete();
    }

    onCenterSelected(event$: MatSelectChange) {
        this.selectedCentre = event$.value
        this.unitsArray = []
        //   console.log(event$.value)
        let centre = event$.value
        this.mUnitService.getUnit(centre.centreCode).pipe(takeUntil(this._destroyed$)).subscribe((units) => {
            this.unitsArray = []

            units.forEach(unit => {
                this.unitsArray.push(unit as Units)
                //  console.log('unit', unit)
                // this.dataSource = new MatTableDataSource(this.unitsArray);
                // this.dataSource.paginator = this.paginator;
            })
        })

    }

    getUnitReport(unit: Unit | undefined, start: Date | undefined, end: Date | undefined) {
        console.log(`unit :${unit} start: ${start},end ${end}`)
    }

    search() {

        this.mFirestore.collection<FullChild>('ALChild').valueChanges().pipe(takeUntil(this._destroyed$)).subscribe(
            res => {
                res.forEach(child => {
                    child.admissionData.forEach((ad, i) => {
                        let add = false
                        if (i % 2 == 0 && ad.dateOfAdmission!!.toDate() >= this.start!! && ad.dateOfAdmission!!.toDate() <= this.end!! && ad.centreCode == this.selectedCentre.centreCode) {
                            // @ts-ignore
                            child.dateOfAdmission = ad.dateOfAdmission?.toDate()
                            add = true
                        }
                        if (add) this.children.push(child)
                    })
                })
                this.dataSource = new MatTableDataSource<FullChild>(this.children)
                this.dataSource.paginator = this.paginator
              this.showDownload =true
                console.log(this.children.length)
            }
        )
    }

    getDiagnosis(diagnosisSelected: any[]) {
        let arr: any[] = []
        diagnosisSelected.forEach((it: any, i: number) => {
            if (diagnosisSelected.length - 1 != i) {
                arr.push(it.name + ",")
            } else {
                arr.push(it.name)
            }
        })
        return arr
    }

    downloadExcel(data: any[], filename: string) {
        let element = document.getElementById('excel-table');

        const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
        // const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(element);
        // const ws: XLSX.WorkSheet =XLSX.utils.json_to_sheet(this.receipts)
        ws['!cols'] = [];
        ws['!cols'][19] = {hidden: true};

        /* O1 is your Column in Excel*/

        /* generate workbook and add the worksheet */
        const wb: XLSX.WorkBook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

        /* save to file */
        XLSX.writeFile(wb, this.selectedCentre.centreName+'.xlsx');
    }
}
